<template>
  <div>
    <back-btn />
    <v-row>
      <v-col lg="10" offset-lg="1">
        <visit-report-view></visit-report-view>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VisitReportView from "@/components/dots/VisitReportView.vue";
import BackBtn from "@/components/navigation/BackBtn.vue";
export default {
  components: {
    VisitReportView,
    BackBtn,
  },
};
</script>

<style></style>
